import { connect } from 'react-redux'
import { RootState } from '../../../../../store'
import {
    getQuoteVariation,
    delQuoteVariation,
    createQuoteVariation,
    issueQuoteVariation,
    updateQuoteVariation,
    updateRenewalVariation,
    bindQuoteVariation,
    checkSoftReferral,
    inviteQuoteVariation,
    renewalBindQuoteVariation,
    getRenewalVariation,
} from '../../../../../actions'

import VariantionContainer from '../components/VariantionContainer'

const mapStateToProps = (state: RootState, props: any) => {
    return {
        step05: state.step05,
        renewalStep05: state.step05Renewals,
        quoteId: props.quoteId,
    }
}

export default connect(
    mapStateToProps,
    {
        getQuoteVariation: getQuoteVariation,
        delQuoteVariation: delQuoteVariation,
        createQuoteVariation: createQuoteVariation,
        issueQuoteVariation: issueQuoteVariation,
        updateQuoteVariation: updateQuoteVariation,
        updateRenewalVariation: updateRenewalVariation,
        bindQuoteVariation: bindQuoteVariation,
        checkSoftReferral: checkSoftReferral,
        inviteQuoteVariation: inviteQuoteVariation,
        renewalBindQuoteVariation: renewalBindQuoteVariation,
        getRenewalVariation: getRenewalVariation,
    }
)(VariantionContainer)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Quote/Step05cp/containers/VariantionContainer.tsx